export function getLogScalePosition(
  value: number,
  minimumValue: number,
  maximumValue: number,
  steps: number
): number {
  const valueRange = maximumValue - minimumValue;
  if (valueRange <= 0) {
    return steps;
  }
  if (value <= minimumValue) {
    return 0;
  }

  return (
    (Math.log1p(Math.min(value, maximumValue) - minimumValue) /
      Math.log1p(valueRange)) *
    steps
  );
}

export function getValueFromLogScalePosition(
  position: number,
  minimumValue: number,
  maximumValue: number,
  steps: number
): number {
  const valueRange = maximumValue - minimumValue;
  if (position <= 0 || valueRange <= 0) {
    return minimumValue;
  }

  const normalizedPosition = Math.min(position, steps) / steps;
  return minimumValue + Math.expm1(normalizedPosition * Math.log1p(valueRange));
}

export function getBucketScalePosition(
  index: number,
  bucketCount: number,
  steps: number
): number {
  return bucketCount > 0 ? ((index + 1) / bucketCount) * steps : steps;
}

export function getBucketHeightRatio(
  amount: number,
  buckets: number[]
): number {
  const maximumAmount = Math.max(...buckets, 1);
  return amount / maximumAmount;
}
